import React from "react";
import { Card, CardBody, CardTitle, Spinner } from "reactstrap";
import { ConnectComponentsProvider, ConnectBalances, ConnectPayouts } from "@stripe/react-connect-js";
import { useStripeConnect } from "./StripeConnectContext";

/**
 * Stripe's own authoritative balance + upcoming/recent payout widgets.
 * Porcher never recreates these values from Firebase — Stripe renders its
 * live data directly.
 */
const StripeBalancePayouts = () => {
  const { status, connectInstance } = useStripeConnect();

  if (!status?.onboardingComplete) return null;

  return (
    <Card className="mb-4">
      <CardBody>
        <CardTitle tag="h5" className="mb-3">Balance &amp; Payouts</CardTitle>

        {connectInstance ? (
          <ConnectComponentsProvider connectInstance={connectInstance}>
            <div className="mb-4">
              <ConnectBalances />
            </div>
            <ConnectPayouts />
          </ConnectComponentsProvider>
        ) : (
          <div className="text-center py-4"><Spinner color="primary" /></div>
        )}
      </CardBody>
    </Card>
  );
};

export default StripeBalancePayouts;
